/**
 * For matching CSS lengths.
 *
 * Procudes two match groups: 1) the numeric portion, and 2) the unit portion.
 * This is used by the CSSLength class.
 */
export const cssLengthMatcher = /^([+-]?(?:(?:[0-9]*\.[0-9]+)|[0-9]+))([a-zA-Z]+|%)$/;
export const mdJsCodeBlockMatcher = /(```javascript(?:.|\n)*?```)/gm;
export const mdCodeFenceRemover = /```(?:\w*)/gm;
